<!--
 * @Author: guoyu
 * @Date: 2020-05-27 15:32:57
 * @LastEditors: your name
 * @LastEditTime: 2020-05-27 17:21:21
 * @Description: 极速约单倒计时
-->
<template>
  <component
    :is="componentsName"
    @animateEnd="switchComponent"
    v-bind="$props"
    @now="emitNow"
    @end="emitEnd"
  ></component>
</template>
<script>
import countdown from './count-down';
import StartAnimate from './start-animate';
export default {
  components: {
    countdown, // 普通倒计时
    StartAnimate, // 约单首次进入弹窗倒计时
  },
  props: {
    prefix: {
      type: [String, Boolean],
    },
    total: {
      type: Number,
      default: 15,
    },
    timestamp: Number,
    background: {
      type: String,
      default: '#323D4F',
    },
    color: {
      type: String,
      default: 'white',
    },
    prefixColor: {
      type: String,
      default: '#323D4F',
    },
    showCountdownPopup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let isFirstComeIn = this.showCountdownPopup;
    return {
      componentsName: isFirstComeIn ? 'StartAnimate' : 'countdown',
    };
  },
  methods: {
    switchComponent() {
      this.componentsName = 'countdown';
    },
    emitNow(e) {
      this.$emit('now', e);
    },
    emitEnd(e) {
      this.$emit('end', e);
    },
  }
};
</script>
